import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    num: 1,
    title: 'El Mapa del Enemigo',
    desc: 'Comprende la estructura del sistema financiero y los actores involucrados.'
  }, {
    num: 2,
    title: 'Derechos y Protección',
    desc: 'Conoce las leyes vigentes que te amparan como consumidor en Uruguay.'
  }, {
    num: 3,
    title: 'Comprender el Sistema',
    desc: 'Aprende cómo se manejan los registros y los plazos legales establecidos.'
  }, {
    num: 4,
    title: 'Estrategias y Opciones',
    desc: 'Explora las alternativas disponibles para abordar tu situación particular.'
  }, {
    num: 5,
    title: 'Herramientas Prácticas',
    desc: 'Modelos y recursos educativos para comunicarte formalmente.'
  }, {
    num: 6,
    title: 'Plan de Acción',
    desc: 'Pasos claros para organizar tus finanzas y proyectar un mejor futuro.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface-gray relative" data-id="element-339">
      <div className="max-w-6xl mx-auto" data-id="element-340">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-341">
          <h2 className="text-3xl md:text-5xl font-black text-slate-dark mb-4" data-id="element-342">
            El contenido del MegaPack
          </h2>
          <p className="text-xl text-slate font-medium" data-id="element-343">
            6 Tomos diseñados para darte claridad total.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-344">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-345">
              {/* Image Placeholder */}
              <div className="h-48 bg-brand-green/5 flex items-center justify-center border-b border-gray-100 relative overflow-hidden" data-id="element-346">
                <div className="absolute inset-0 bg-gradient-to-br from-brand-light/20 to-brand-green/20" data-id="element-347" />
                <span className="relative z-10 font-montserrat font-black text-4xl text-brand-green/30" data-id="element-348">
                  TOMO {tomo.num}
                </span>
              </div>

              <div className="p-6 flex flex-col flex-1" data-id="element-349">
                <div className="text-brand-green text-sm font-bold tracking-wider mb-2" data-id="element-350">
                  TOMO {tomo.num}
                </div>
                <h5 className="text-xl font-black text-slate-dark mb-3" data-id="element-351">
                  {tomo.title}
                </h5>
                <p className="text-slate text-sm leading-relaxed mt-auto" data-id="element-352">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm max-w-3xl mx-auto text-center" data-id="element-353">
          <h3 className="text-xl font-bold text-slate-dark mb-6" data-id="element-354">
            Además, dentro de cada tomo encontrarás:
          </h3>
          <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-12" data-id="element-355">
            <div className="flex items-center justify-center gap-2 text-slate font-medium" data-id="element-356">
              <span className="text-brand-green font-bold" data-id="element-357">✓</span> Capturas
              reales del contenido
            </div>
            <div className="flex items-center justify-center gap-2 text-slate font-medium" data-id="element-358">
              <span className="text-brand-green font-bold" data-id="element-359">✓</span> Ejemplos
              internos
            </div>
            <div className="flex items-center justify-center gap-2 text-slate font-medium" data-id="element-360">
              <span className="text-brand-green font-bold" data-id="element-361">✓</span> Índice
              incluido
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}